<template>
  <!-- May need to check for Application type to disply new vs. old styles -->
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <h2
      v-if="data.title"
      class="cf-title cf-title--2"
    >
      {{ data.title }}
    </h2>

    <p
      class="cf-subtitle cf-subtitle--2"
      v-html="data.primaryText"
    />

    <p
      v-if="data.secondaryText"
      class="cf-subtitle cf-subtitle--2"
      v-html="data.secondaryText"
    />

    <button
      :class="['cf-button cf-button--primary cf-button--lg', { 'cf-button--loading': confirmationActionIsProcessing }]"
      type="button"
      @click="confirmationModalConfirmedHandler(data)"
    >
      {{ data.ctaConfirmText || 'Continue' }}
    </button>

    <button
      v-if="!data.hideSecondaryCta"
      class="cf-button cf-button--secondary cf-button--lg"
      type="button"
      @click="$closeModal('confirmation')"
    >
      {{ data.ctaCancelText || 'Never Mind' }}
    </button>
  </div>
</template>


<script>
  import errorHandlers from '@/services/error-handlers';


  export default {
    name: 'Confirmation',

    props: {
      data: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        confirmationActionIsProcessing: false
      };
    },

    methods: {
      async confirmationModalConfirmedHandler(data) {
        try {
          this.confirmationActionIsProcessing = true;

          await data.onConfirm();

          if (data.onConfirmSuccess) {
            data.onConfirmSuccess();
          }

          this.$closeModal('confirmation');
        }

        catch (error) {
          errorHandlers.generic(error);
        }

        finally {
          this.confirmationActionIsProcessing = false;
        }
      }
    }
  };
</script>
